'use client'

import { useGoogleAnalytics } from '@/lib/analytics'

export function GoogleAnalyticsProvider() {
  useGoogleAnalytics()
  return null
}
